import { FieldAPI } from '@philips-internal/oswald-ui-components';
import { PredefinedValidators } from '../../utils/predefined-validators';

export const AccountCreationArgentinaHelper = {
  handlePersonIdsFieldsWhenOutFocus,
};

/**
 * Adds the mandatory validator if the field has a value and forces the fields to be revalidated.
 * @param currentField The current field that experienced the out focus event.
 * @param dependentField The second field that needs to have its value checked in an out focus event.
 */
function handlePersonIdsFieldsWhenOutFocus(currentField: FieldAPI, dependentField: FieldAPI): void {
  const currentFieldValue = currentField.getValue();
  const requiredValidator = PredefinedValidators.required();
  if (currentFieldValue && !currentField.getValidators().some(v => v.name === requiredValidator.name)) {
    currentField.addValidator(requiredValidator);
  }

  forceValidateForPersonIdsArgentina(currentField, dependentField);
}

/**
 * If any of the fields has no value, its mandatory validator is checked and removed and,
 * at the end, a new validation of the fields is performed.
 * @param currentField The current field that experienced the out focus event.
 * @param dependentField The second field that needs to have its value checked in an out focus event.
 */
function forceValidateForPersonIdsArgentina(currentField: FieldAPI, dependentField: FieldAPI): void {
  const requiredValidatorName = PredefinedValidators.required().name;
  if (currentField.getValue() && !dependentField.getValue()) {
    dependentField.removeValidator(requiredValidatorName);
  } else if (!currentField.getValue() && dependentField.getValue()) {
    currentField.removeValidator(requiredValidatorName);
  }

  /**
   * Without using "setTimeout", calling "validate()" does not update the state of "Field".
   */
  setTimeout(async () => {
    await currentField.validate();
    await dependentField.validate();
  });
}